var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19,
  viewBox: "0 0 19 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-message-circle",
  "data-name": "Icon feather-message-circle",
  d: "M12.954,3H13.5A9.006,9.006,0,0,1,22,11.5q0,.026,0,.052v.475a9.029,9.029,0,0,1-9.025,9.025h-.021A8.959,8.959,0,0,1,9.3,20.267L4.25,21.951a.95.95,0,0,1-1.2-1.2L4.733,15.7A9.029,9.029,0,0,1,12.954,3Zm.469,1.9h-.469a7.045,7.045,0,0,0-3.161.753l0,0A7.114,7.114,0,0,0,6.6,15.207a.95.95,0,0,1,.053.729l-1.2,3.613,3.613-1.2a.95.95,0,0,1,.729.053,7.045,7.045,0,0,0,3.161.753h.018a7.087,7.087,0,0,0,6.373-3.94l0,0a7.044,7.044,0,0,0,.753-3.179v-.45A7.1,7.1,0,0,0,13.423,4.9Z",
  transform: "translate(-3 -3)",
  fill: "currentColor"
})));
export { SvgChat as ReactComponent };
export default __webpack_public_path__ + "static/media/chat.b558cc71c9be7dc2016c988e1d41df99.svg";